import { Injectable, inject } from '@angular/core';
import { LocationService } from '../location/location.service';
import { ProfileService } from 'src/app/core/services/profile/profile.service';
import { InitService } from '../init/init.service';
import { AnalyticsService } from '../analytics/analytics.service';

@Injectable({
  providedIn: 'root',
})
export class SignOutService {
  private analyticsService = inject(AnalyticsService);
  private locationService = inject(LocationService);
  private profileService = inject(ProfileService);
  private initService = inject(InitService);

  async signOut(): Promise<void> {
    this.analyticsService.signOut();
    this.locationService.signOut();
    this.profileService.reset();
    this.initService.reset();
  }
}
